import F from "../../Functions";

export const getAutoAndHomeValue = (data = {}, rac_calculator = 0, home_toggle = "") => {

    let recommended_limit = "";
    let recommended_limit_2 = "";
    let autoUnderlyingLimit = data.minimum_liability_limits_ext && data.minimum_liability_limits_ext["Auto"];
    let homeUnderlyingLimit = data.minimum_liability_limits_ext && data.minimum_liability_limits_ext["Home"];
    let minimum_liability_limits = data.minimum_liability_limits;


    if ((data.carrier !== null &&
        data.carrier === "Farm Bureau") ||
        (data.carrier === "Farm Bureau" &&
            autoUnderlyingLimit &&
            homeUnderlyingLimit)
    ) {

        switch (autoUnderlyingLimit) {
            case "100/300":
                if (
                    rac_calculator &&
                    rac_calculator <= 249999 &&
                    rac_calculator > 0
                )
                    recommended_limit = "$100,000/$300,000";
                else if (
                    rac_calculator &&
                    rac_calculator > 249999 &&
                    rac_calculator > 0
                )
                    recommended_limit = "$500,000/$500,000";
                break;
            case "250/500":
                if (
                    rac_calculator &&
                    rac_calculator <= 249999 &&
                    rac_calculator > 0
                )
                    recommended_limit = "$250,000/$500,000";
                else if (
                    rac_calculator &&
                    rac_calculator > 249999 &&
                    rac_calculator > 0
                )
                    recommended_limit = "$500,000/$500,000";
                break;
            case "500/500":
                recommended_limit = "$500,000/$500,000";
                break;
            default:
                if (
                    rac_calculator &&
                    rac_calculator <= 99999 &&
                    rac_calculator > 0
                )
                    recommended_limit = "$100,000/$300,000";
                if (
                    rac_calculator &&
                    rac_calculator > 99999 &&
                    rac_calculator <= 249999 &&
                    rac_calculator > 0
                )
                    recommended_limit = "$250,000/$500,000";
                if (
                    rac_calculator &&
                    rac_calculator > 249999 &&
                    rac_calculator > 0
                )
                    recommended_limit = "$500,000/$500,000";
                break;
        }

        switch (homeUnderlyingLimit) {
            case "300,000":
                if (
                    rac_calculator &&
                    rac_calculator <= 249999 &&
                    rac_calculator > 0
                )
                    recommended_limit_2 = "$300,000";
                else if (rac_calculator && rac_calculator > 249999)
                    recommended_limit_2 = "$500,000";
                break;
            case "500,000":
                if (rac_calculator && rac_calculator > 0)
                    recommended_limit_2 = "$500,000";
                break;
            default:
                if (
                    rac_calculator &&
                    rac_calculator <= 99999 &&
                    rac_calculator > 0
                )
                    recommended_limit_2 = "$100,000";
                if (
                    rac_calculator &&
                    rac_calculator > 99999 &&
                    rac_calculator <= 249999
                )
                    recommended_limit_2 = "$300,000";
                if (rac_calculator && rac_calculator > 249999)
                    recommended_limit_2 = "$500,000";
                break;
        }

    }

    if (
        data.carrier !== null &&
        data.carrier !== "Farm Bureau" &&
        autoUnderlyingLimit &&
        homeUnderlyingLimit
    ) {
        if (rac_calculator && rac_calculator != 0 && rac_calculator < 25000) {
            recommended_limit = "$25,000/$50,000";
            recommended_limit_2 = home_toggle == "1" ? "$100,000" : ""; //home
        }
        if (
            rac_calculator &&
            rac_calculator >= 25000 &&
            rac_calculator < 50000
        ) {
            recommended_limit_2 = home_toggle == "1" ? "$100,000" : ""; //home
            recommended_limit = "$50,000/$100,000"; //auto
        }
        if (
            rac_calculator &&
            rac_calculator >= 50000 &&
            rac_calculator < 100000
        ) {
            recommended_limit_2 = home_toggle == "1" ? "$100,000" : ""; //home
            recommended_limit = "$100,000/$300,000"; //auto
        }
        if (
            rac_calculator &&
            rac_calculator >= 100000 &&
            rac_calculator < 250000
        ) {
            recommended_limit_2 = home_toggle == "0" ? "" : "$300,000"; //home
            recommended_limit = "$250,000/$500,000"; //auto
        }
        if (
            rac_calculator &&
            rac_calculator >= 250000 &&
            rac_calculator < 500000
        ) {
            recommended_limit_2 = home_toggle == "0" ? "" : "$500,000"; //home
            recommended_limit = "$500,000/$1,000,000"; //auto
        }
        if (
            rac_calculator &&
            rac_calculator >= 500000 &&
            rac_calculator < 600000
        ) {
            recommended_limit_2 = home_toggle == "0" ? "" : "$300,000"; //home
            recommended_limit = "$250,000/$500,000"; //auto
        }
        if (
            rac_calculator &&
            rac_calculator > 600000 &&
            rac_calculator < 1300000
        ) {
            recommended_limit_2 = home_toggle == "0" ? "" : "$300,000"; //home
            recommended_limit = "$250,000/$500,000"; //auto
        }
        if (
            rac_calculator &&
            rac_calculator >= 1300000 &&
            rac_calculator < 2300000
        ) {
            recommended_limit_2 = home_toggle == "0" ? "" : "$300,000"; //home
            recommended_limit = "$250,000/$500,000"; //auto
        }
        if (
            rac_calculator &&
            rac_calculator >= 2300000 &&
            rac_calculator < 4000000
        ) {
            recommended_limit_2 = home_toggle == "0" ? "" : "$300,000"; //home
            recommended_limit = "$250,000/$500,000"; //auto
        }
        if (
            rac_calculator &&
            rac_calculator >= 4000000 &&
            rac_calculator < 5000000
        ) {
            recommended_limit_2 = home_toggle == "0" ? "" : "$300,000"; //home
            recommended_limit = "$250,000/$500,000"; //auto
        }
        if (rac_calculator && rac_calculator >= 5000000) {
            recommended_limit_2 = home_toggle == "0" ? "" : "$300,000"; //home
            recommended_limit = "$250,000/$500,000"; //auto
        }
    }

    if (
        (minimum_liability_limits &&
            data.carrier !== null &&
            data.carrier !== "Farm Bureau") ||
        (data.carrier && data.carrier !== "Farm Bureau")
    ) {
        const recommended_limit_f = F.get_first_value(
            recommended_limit.replace("/", "-")
        ); // 250,000

        if (minimum_liability_limits === "$25,000/$50,000") {
            recommended_limit = "$25,000/$50,000";
            recommended_limit_2 = "$100,000";
        }

        if (minimum_liability_limits === "$50,000/$100,000") {
            recommended_limit = "$50,000/$100,000";
            recommended_limit_2 = "$100,000";
        }

        if (minimum_liability_limits === "$100,000/$300,000") {
            if (recommended_limit_f <= 100000) {
                recommended_limit = "$100,000/$300,000";
                recommended_limit_2 = "$100,000";
            }
        }

        if (minimum_liability_limits === "$250,000/$500,000") {
            if (recommended_limit_f <= 250000) {
                recommended_limit =
                    data.carrier === "Farm Bureau"
                        ? "$500,000/$500,000"
                        : "$250,000/$500,000";
                recommended_limit_2 = "$300,000";
            }
        }

        if (minimum_liability_limits === "$500,000/$1,000,000") {
            recommended_limit = "$500,000/$1,000,000";
            recommended_limit_2 = "$500,000";
        }
    }
    recommended_limit = recommended_limit ? F.dollar_format(recommended_limit) : ""
    recommended_limit_2 = recommended_limit_2 ? F.dollar_format(recommended_limit_2) : ""
    return { recommended_limit, recommended_limit_2 }
}



// WEBPACK FOOTER //
// ./src/components/print-pdf/helpers.js